/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InternalUser = {
    xtrfUserId: number;
    email: string;
    firstName: string;
    lastName: string;
    status: InternalUser.status;
};
export namespace InternalUser {
    export enum status {
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
    }
}

